// @core/api/endpoints/subscription/list_entitlements.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEntitlementsResponse,
} from '../../../types/subscription';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/subscription';

/**
 * List tenant entitlements
 * Returns all active entitlements for a tenant across all subscriptions and addons.
 */
export async function ListEntitlements(
  tenant_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListEntitlementsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tenants/:tenant_id/entitlements`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<ListEntitlementsResponse>(requestPath, { ...requestOptions, params });
}
